import { Pipe, PipeTransform } from '@angular/core';
import { TranslateService } from '@ngx-translate/core';

@Pipe({
  name: 'minutesLater',
  standalone: true
})
export class MinutesLaterPipe implements PipeTransform {
  constructor(private translate: TranslateService) {}

  transform(value: any, mins?: any): string {
    if (!mins) mins = 30;

    let dateTime = new Date(value);
    dateTime.setMinutes(dateTime.getMinutes() + 30);

    return dateTime.toISOString();
  }
}
